import { render, staticRenderFns } from "./DropdownV2.vue?vue&type=template&id=615e5c40&scoped=true&"
import script from "./DropdownV2.vue?vue&type=script&lang=js&"
export * from "./DropdownV2.vue?vue&type=script&lang=js&"
import style0 from "./DropdownV2.vue?vue&type=style&index=0&id=615e5c40&lang=scss&scoped=true&"
import style1 from "./DropdownV2.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615e5c40",
  null
  
)

export default component.exports